// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3_cTn","calendarButtons":"ClockData_calendarButtons__5vz90"};